<template lang="pug">
.PassageProgressComponent
  ui-loader(v-if="isLoading")
  template(v-else)
    .books(
      v-if="childBooks.length"
    )
      ui-child-item.item(
        v-for="childBook in childBooks"
        :key="childBook.userItem.id"
        :child-item="childBook"
        @action:click-on-item="onBookClick(childBook.userItem.book.id)"
      )
    p.noBooks(v-else) У Вас еще нет купленных книг для прохождения
</template>

<script>
import { inject, watch } from '@vue/runtime-core'
import ChildBookListController from '@/controllers/ChildBook/ChildBookListController'

export default {
  setup () {
    const store = inject('store')
    const { childBooks, childProgressRequest, isLoading } = ChildBookListController()
    watch(() => store.user.selectedChild.id, (childId) => { childProgressRequest(childId) }, { immediate: true })

    return { childBooks, isLoading }
  },
  methods: {
    onBookClick (id) {
      this.$router.push({ name: 'Book', params: { id } })
    }
  }

}
</script>

<style lang="sass" scoped>
.PassageProgressComponent
  > .books
    display: grid
    grid-template-columns: repeat(3, 1fr)
    grid-gap: 7.5*$u

    > .book
      cursor: pointer

  > .noBooks
    text-align: center

@media (max-width: $XXXLWidth)
  .PassageProgressComponent
    .books
      grid-template-columns: repeat(2, 1fr)
@media (max-width: $MWidth)
  .PassageProgressComponent
    .books
      grid-template-columns: repeat(1, 1fr)
</style>
